import React, { createContext, PropsWithChildren, useContext } from "react"
import redirectToApp, { redirectToAfterExternalLogin } from "@cirrus/app-common/login/redirectToApp"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { StartPagePath } from "../route/paths"
import { AuthResponse } from "./LoginService"

export class NavigationService {
	search: Record<string, string> = {}
	useParams: () => any = () => undefined
	navigate: (path: StartPagePath | -1) => any = (path) => console.debug("Navigate: ", path)
	redirectToApp: (authResult: AuthResponse) => any = (authResult) => console.debug(authResult)
	redirectToAfterExternalLogin: (authResult: AuthResponse) => any = (authResult) => console.debug(authResult)
}

const NavigationServiceContext = createContext(new NavigationService())

export const useNavigationService = () => useContext(NavigationServiceContext)

export const NavigationServiceProvider = ({
	children, service
}: PropsWithChildren & {
	service: NavigationService
}) => {
	return (<NavigationServiceContext.Provider value={service}>
		{children}
	</NavigationServiceContext.Provider>)
}

export const WithAppNavigationService = ({ children }) => {
	const history = useHistory()
	const { search } = useLocation()

	return (<NavigationServiceProvider service={{
		search: Object.fromEntries(new URLSearchParams(search)),
		useParams, // Pass hook instead of its returned data because the params are invisible outside their Route components
		redirectToApp,
		redirectToAfterExternalLogin,
		navigate: (path) => path === -1 ? history.goBack() : history.push(path)
	}}>
		{children}
	</NavigationServiceProvider>)
}
